<template>
  <InputBase
    v-bind="$attrs"
    :modelValue="modelValue"
    :size="size"
    :typeField="type"
    :placeholder="placeholder"
    :description="description"
    :suffix="suffix"
    :suffixIcon="suffixIcon"
    :errorText="errorText"
    :positionError="positionError"
    :isError="isError"
    :disabled="disabled"
    :readOnly="readOnly"
    :textarea="textarea"
    :minHeightTextArea="minHeightTextArea"
    :autoResizeTextarea="autoResizeTextarea"
    :rootClass="[style.inputStyle, ...classes]"
    @update:modelValue="$emit('update:modelValue', $event)"
    @input="$emit('input', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  >
    <template #prefixInput>
      <slot name="prefixInput" />
    </template>

    <template v-if="$slots.actions" #actions="slotProps">
      <slot name="actions" v-bind="slotProps" />
    </template>
  </InputBase>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import InputBase from "../Base/InputBase.vue";
import style from "./InputStyle.module.scss";

type InputType = "text" | "password" | "email" | "tel" | "number" | "url";
type ErrorPosition = "top" | "bottom";

export default defineComponent({
  name: "InputStyle",

  components: {InputBase},

  inheritAttrs: false,

  emits: ["update:modelValue", "input", "focus", "blur"],

  props: {
    classes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    modelValue: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    type: {
      type: String as PropType<InputType>,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    errorText: {
      type: String,
      default: ""
    },
    positionError: {
      type: String as PropType<ErrorPosition>,
      default: "top"
    },
    isError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    textarea: {
      type: Boolean,
      default: false
    },
    minHeightTextArea: {
      type: Number,
      default: 20
    },
    autoResizeTextarea: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      style
    };
  }
});
</script>
